export const ptoApprovalNotesComponent = {
  templateUrl: "admin/views/pto-approval-notes-modal.html",
  controller: "ptoApprovalNotesModalCtrl"
  // Controller data is stored in ptoNotesModalService.notesData
};
